export type BlogCoverKey = "inside-a-referral-system" | "why-satisfied-clients-dont-refer";

export type BlogCoverContent = {
  eyebrow: string;
  headlineLines: string[];
  subhead: string;
};

export const blogCovers: Record<BlogCoverKey, BlogCoverContent> = {
  "inside-a-referral-system": {
    eyebrow: "REFERRAL SYSTEMS FOR RIA FIRMS",
    headlineLines: ["Inside a Referral", "System"],
    subhead: "What it actually looks like at a 10-person RIA",
  },
  "why-satisfied-clients-dont-refer": {
    eyebrow: "REFERRAL SYSTEMS FOR RIA FIRMS",
    headlineLines: ["Why Satisfied Clients", "Don't Refer You"],
    subhead: "And what actually earns advocacy",
  },
};

export function isBlogCoverKey(value: string): value is BlogCoverKey {
  return value in blogCovers;
}

function escapeXml(value: string) {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&apos;");
}

export function renderBlogCoverSvg(content: BlogCoverContent) {
  const headline = content.headlineLines
    .map((line, index) => `<tspan x="112" dy="${index === 0 ? 0 : 76}">${escapeXml(line)}</tspan>`)
    .join("");

  return `<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="630" viewBox="0 0 1200 630" role="img" aria-labelledby="title description">
  <title id="title">${escapeXml(content.headlineLines.join(" "))}</title>
  <desc id="description">${escapeXml(content.subhead)}</desc>
  <rect width="1200" height="630" fill="#F5F1E9"/>
  <rect width="14" height="630" fill="#9C3A11"/>
  <text x="112" y="116" fill="#9C3A11" font-family="Arial, Helvetica, sans-serif" font-size="23" font-weight="700" letter-spacing="4">${escapeXml(content.eyebrow)}</text>
  <text x="112" y="242" fill="#1A2E21" font-family="Georgia, 'Times New Roman', serif" font-size="70" font-weight="700" letter-spacing="0">${headline}</text>
  <text x="112" y="430" fill="#828E78" font-family="Georgia, 'Times New Roman', serif" font-size="32" font-weight="400" letter-spacing="0">${escapeXml(content.subhead)}</text>
  <rect x="112" y="470" width="140" height="3" fill="#9C3A11"/>
  <g transform="translate(1022 444)">
    <circle cx="62" cy="62" r="60" fill="#F5F1E9" stroke="#9C3A11" stroke-width="2"/>
    <text x="62" y="58" text-anchor="middle" fill="#1A2E21" font-family="Arial, Helvetica, sans-serif" font-size="34" font-weight="700" letter-spacing="2">FS</text>
    <text x="62" y="94" text-anchor="middle" fill="#9C3A11" font-family="Arial, Helvetica, sans-serif" font-size="34" font-weight="700" letter-spacing="2">GE</text>
    <text x="62" y="149" text-anchor="middle" fill="#828E78" font-family="Arial, Helvetica, sans-serif" font-size="18" font-weight="700" letter-spacing="3">FSGE</text>
  </g>
</svg>`;
}